import React from 'react';
import { createStyles, Title, Box, Grid } from '@mantine/core';
import { themeColors } from '../config/themeSettings';
import { Routes, Route, useParams } from 'react-router-dom';

import NewsCard from './components/NewsCard';
import PoliceAppLaunch from './news/PoliceAppLaunch';
import TraffickingRacketBust from './news/TraffickingRacketBust';
import PaharganjSpaRaid from './news/PaharganjSpaRaid';
import AiSafetyAppBust from './news/AiSafetyAppBust';
import IndiatodayTraffickingBust from './news/IndiatodayTraffickingBust';
import DevdiscourseTraffickingBust from './news/DevdiscourseTraffickingBust';
import DelhiPoliceSwiftAssistance from './news/DelhiPoliceSwiftAssistance';
import BwPoliceWorldArticle from './news/BwPoliceWorldArticle';
import IndiaAutoRickshawRally from './news/IndiaAutoRickshawRally';
import SocialImpactMeeting from './news/SocialImpactMeeting';
import HomePage from './HomePage';

const news = [
  {
    imageSrc:
      'https://apdirect.in/wp-content/uploads/2025/12/img_4715.jpg',
    category: 'INDIA NEWS',
    title:
      'Meeting Highlights Social Impact of "Say Help" Personal Safety Application',
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Marter Bagra',
    date: 'December 21, 2025',
    newsId: 'social-impact-meeting',
    source: 'AP Direct',
  },
  {
    imageSrc:
      'https://static.businessworld.in/IMG_20251213_130258_20251213172204_original_image_14.webp',
    category: 'INDIA NEWS',
    title:
      "SAYHELP App reaches masses, Nirbhaya's mother flags off over 500 auto rickshaws in a rally",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'BW Online Bureau',
    date: 'December 13, 2025',
    newsId: 'india-auto-rickshaw-rally',
    source: 'BW Police World',
  },
  {
    imageSrc:
      'https://static.businessworld.in/IMG_20251211_100720_20251211100901_original_image_27.webp',
    category: 'INDIA NEWS',
    title:
      "'Say Help' app set to be implemented across Delhi with it's success in just three months of arriving in India",
    authorAvatarSrc:
      'https://static.businessworld.in/UW3RSN_IMG_20210303_145041.jpg',
    authorName: 'Ujjawala Sushil Nayudu',
    date: 'December 10, 2025',
    newsId: 'bw-police-world-delhi-implementation',
    source: 'BW Police World',
  },
  {
    imageSrc:
      'https://static.toiimg.com/thumb/msid-125116262,imgsize-21232,width-400,height-225,resizemode-72/police-a-tap-away-for-women-and-elderly-just-say-help.jpg',
    category: 'INDIA NEWS',
    title: "Police a tap away for women and elderly. Just 'Say Help'",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Abhay',
    date: 'Nov 06, 2025, 02:37 IST',
    newsId: 'police-app-launch',
    source: 'Times of India',
  },
  {
    imageSrc:
      'https://media.newindianexpress.com/newindianexpress%2F2025-11-06%2Fyydapcx6%2Fdelhi-police-1.JPG?w=1200&auto=format%2Ccompress&fit=max',
    category: 'INDIA NEWS',
    title:
      "Delhi Police busts trafficking racket in Paharganj spa after alert from 'Say Help' app",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Express News Service',
    date: '06 Nov 2025, 9:45 am',
    newsId: 'trafficking-racket-bust',
    source: 'The New Indian Express',
  },
  {
    imageSrc:
      'https://www.tribuneindia.com/sortd-service/imaginary/v22-01/jpg/large/high?url=dGhldHJpYnVuZS1zb3J0ZC1wcm8tcHJvZC1zb3J0ZC9tZWRpYTZhNGNkNjMwLWJhZGItMTFmMC1iMDY0LWVkNWUyYTYzNDljNy5qcGc=',
    category: 'INDIA NEWS',
    title:
      "Delhi's Paharganj spa immoral trafficking racket busted via 'Say Help' app alert",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Tribune News Service',
    date: '12:09 PM Nov 06, 2025 IST',
    newsId: 'paharganj-spa-raid',
    source: 'Tribune India',
  },
  {
    imageSrc: '/static/media/about-photo-2.1f82417f40ffb13ef686.jpg',
    category: 'INDIA NEWS',
    title:
      'AI-enabled safety app helps bust prostitution racket in Paharganj; six women rescued',
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'The Hindu Bureau',
    date: 'November 07, 2025 01:36 am IST',
    newsId: 'ai-safety-app-bust',
    source: 'The Hindu',
  },
  {
    imageSrc:
      'https://akm-img-a-in.tosshub.com/indiatoday/images/story/202511/delhi-spa-operating-immoral-trafficking-065954438-16x9_0.png?VersionId=9l2bX9cX9fjp9jSUXYwVp_VPdFWjHHdX&size=690:388',
    category: 'INDIA NEWS',
    title:
      'AI-based safety app helps bust immoral trafficking racket at Delhi spa, 6 rescued',
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Arvind Ojha',
    date: 'Nov 6, 2025 14:32 IST',
    newsId: 'indiatoday-trafficking-bust',
    source: 'India Today',
  },
  {
    imageSrc:
      'https://www.devdiscourse.com/remote.axd?https://devdiscourse.blob.core.windows.net/devnews/06_11_2025_20_46_14_7595066.jpg?width=920&format=webp',
    category: 'INDIA NEWS',
    title:
      "Delhi Police Busts Human Trafficking Operation in Paharganj with 'Say Help' App",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Devdiscourse News Desk',
    date: '06-11-2025 20:47 IST',
    newsId: 'devdiscourse-trafficking-bust',
    source: 'Devdiscourse',
  },
];

function NewsOutlet() {
  let { newsId } = useParams();

  switch (newsId) {
    case 'social-impact-meeting':
      return <SocialImpactMeeting />;
    case 'india-auto-rickshaw-rally':
      return <IndiaAutoRickshawRally />;
    case 'bw-police-world-delhi-implementation':
      return <BwPoliceWorldArticle />;
    case 'police-app-launch':
      return <PoliceAppLaunch />;
    case 'trafficking-racket-bust':
      return <TraffickingRacketBust />;
    case 'paharganj-spa-raid':
      return <PaharganjSpaRaid />;
    case 'ai-safety-app-bust':
      return <AiSafetyAppBust />;
    case 'indiatoday-trafficking-bust':
      return <IndiatodayTraffickingBust />;
    case 'devdiscourse-trafficking-bust':
      return <DevdiscourseTraffickingBust />;
    case 'delhi-police-swift-assistance':
      return <DelhiPoliceSwiftAssistance />;
    default:
      return <HomePage />;
  }
}

const NewsContent = () => {
  const { classes } = useStyles();
  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <section className={classes.header}>
                <Title order={2} className={classes.title}>
                  Say Help India
                </Title>
              </section>
              <div className={classes.container}>
                <Box className={classes.sectionCenter}>
                  <Grid grow>
                    {news.map((newsItem, index) => (
                      <Grid.Col span={12} md={6} key={index}>
                        <NewsCard {...newsItem} />
                      </Grid.Col>
                    ))}
                  </Grid>
                </Box>
              </div>
            </div>
          }
        />
        <Route path="/:newsId" element={<NewsOutlet />} />
      </Routes>
    </div>
  );
};

export default NewsContent;

const useStyles = createStyles(theme => ({
  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
